/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ContainerType = "Multi" | "Single" | "%future added value";
export type UrnType = "Date" | "Email" | "Event" | "FlowState" | "Guest" | "Org" | "Phone" | "Services" | "Setting" | "Team" | "Teammate" | "TimeZone" | "User" | "WorkOsOrg" | "WorkingGroup" | "WorkingHours" | "%future added value";
export type ValueType = "Boolean" | "Long" | "Numeric" | "String" | "%future added value";
export type ChromeFeed_viewer = {
    readonly user: {
        readonly givenName: string | null;
        readonly createdTime: unknown | null;
        readonly chromeExtensionFlagsErrorable: ({
            readonly __typename: "GraphEntityError";
            readonly statusCode: number | null;
            readonly message: string | null;
        } | {
            readonly __typename: "Flags";
            readonly flags: ReadonlyArray<string | null> | null;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        }) | null;
        readonly flowStates: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly flowKey: string | null;
                    readonly current: {
                        readonly state: string | null;
                        readonly percentComplete: number | null;
                        readonly errorMessage: string | null;
                    } | null;
                    readonly pending: {
                        readonly state: string | null;
                        readonly percentComplete: number | null;
                        readonly errorMessage: string | null;
                    } | null;
                    readonly " $fragmentRefs": FragmentRefs<"FastCrawlLoader_flowState">;
                } | null;
            } | null> | null;
        } | null;
        readonly orgs: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly orgMeetingHours: {
                        readonly workingHours: {
                            readonly timeZone: string | null;
                        } | null;
                    } | null;
                    readonly experiments: ReadonlyArray<string | null> | null;
                    readonly primaryTeam: ({
                        readonly __typename: "Team";
                        readonly teamId: string;
                        readonly teamName: string;
                    } | {
                        readonly __typename: "GraphEntityError";
                        readonly statusCode: number | null;
                        readonly message: string | null;
                    } | {
                        /*This will never be '%other', but we need some
                        value in case none of the concrete values match.*/
                        readonly __typename: "%other";
                    }) | null;
                    readonly featureGrid: {
                        readonly __typename: "FeatureGrid";
                        readonly stateMetadata: {
                            readonly primaryBillingGroupMetadata: {
                                readonly subscription: {
                                    readonly id: string;
                                };
                            } | null;
                            readonly userMetadata: {
                                readonly person: {
                                    readonly primaryCalendarId: string;
                                };
                                readonly trialMetadata: {
                                    readonly trialEndDate: string;
                                    readonly timeZone: string;
                                } | null;
                            } | null;
                        };
                    } | {
                        readonly __typename: "GraphEntityError";
                        readonly statusCode: number | null;
                        readonly message: string | null;
                    } | {
                        /*This will never be '%other', but we need some
                        value in case none of the concrete values match.*/
                        readonly __typename: "%other";
                    };
                    readonly settings: {
                        readonly edges: ReadonlyArray<{
                            readonly node: {
                                readonly id: string;
                                readonly key: {
                                    readonly id: string;
                                    readonly name: string | null;
                                    readonly scope: {
                                        readonly id: string;
                                        readonly type: UrnType | null;
                                        readonly value: string | null;
                                    } | null;
                                    readonly target: {
                                        readonly id: string;
                                        readonly type: UrnType | null;
                                        readonly value: string | null;
                                    } | null;
                                } | null;
                                readonly type: {
                                    readonly id: string;
                                    readonly valueType: ValueType | null;
                                    readonly containerType: ContainerType | null;
                                    readonly required: boolean | null;
                                } | null;
                                readonly value: ReadonlyArray<string | null> | null;
                            } | null;
                        } | null> | null;
                    } | null;
                    readonly " $fragmentRefs": FragmentRefs<"FeedScheduler_org">;
                } | null;
            } | null> | null;
        };
    } | null;
    readonly " $refType": "ChromeFeed_viewer";
};
export type ChromeFeed_viewer$data = ChromeFeed_viewer;
export type ChromeFeed_viewer$key = {
    readonly " $data"?: ChromeFeed_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ChromeFeed_viewer">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v1 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "statusCode",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
            }
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v2 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v3 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "percentComplete",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "errorMessage",
            "storageKey": null
        } as any
    ], v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timeZone",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
    } as any, v7 = [
        (v4 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
        } as any,
        (v6 /*: any*/)
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "ChromeFeed_viewer",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "givenName",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdTime",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "chromeExtensionFlagsErrorable",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            (v1 /*: any*/),
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "flags",
                                        "storageKey": null
                                    }
                                ],
                                "type": "Flags",
                                "abstractKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": (v2 /*: any*/),
                        "concreteType": "FlowStateConnection",
                        "kind": "LinkedField",
                        "name": "flowStates",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "FlowStateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FlowState",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "flowKey",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "FlowStatus",
                                                "kind": "LinkedField",
                                                "name": "current",
                                                "plural": false,
                                                "selections": (v3 /*: any*/),
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "FlowStatus",
                                                "kind": "LinkedField",
                                                "name": "pending",
                                                "plural": false,
                                                "selections": (v3 /*: any*/),
                                                "storageKey": null
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "FastCrawlLoader_flowState"
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": "flowStates(first:1000000)"
                    },
                    {
                        "alias": null,
                        "args": (v2 /*: any*/),
                        "concreteType": "OrgConnection",
                        "kind": "LinkedField",
                        "name": "orgs",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrgEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Org",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            (v4 /*: any*/),
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "OrgMeetingHours",
                                                "kind": "LinkedField",
                                                "name": "orgMeetingHours",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "WorkingHours",
                                                        "kind": "LinkedField",
                                                        "name": "workingHours",
                                                        "plural": false,
                                                        "selections": [
                                                            (v5 /*: any*/)
                                                        ],
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "experiments",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "primaryTeam",
                                                "plural": false,
                                                "selections": [
                                                    (v0 /*: any*/),
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "teamId",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "teamName",
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "type": "Team",
                                                        "abstractKey": null
                                                    },
                                                    (v1 /*: any*/)
                                                ],
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "featureGrid",
                                                "plural": false,
                                                "selections": [
                                                    (v0 /*: any*/),
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "PaymentStateMetadata",
                                                                "kind": "LinkedField",
                                                                "name": "stateMetadata",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "concreteType": "PrimaryBillingGroupMetadata",
                                                                        "kind": "LinkedField",
                                                                        "name": "primaryBillingGroupMetadata",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "alias": null,
                                                                                "args": null,
                                                                                "concreteType": "PaymentSubscription",
                                                                                "kind": "LinkedField",
                                                                                "name": "subscription",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    (v4 /*: any*/)
                                                                                ],
                                                                                "storageKey": null
                                                                            }
                                                                        ],
                                                                        "storageKey": null
                                                                    },
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "concreteType": "UserMetadata",
                                                                        "kind": "LinkedField",
                                                                        "name": "userMetadata",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "alias": null,
                                                                                "args": null,
                                                                                "concreteType": "OrgPerson",
                                                                                "kind": "LinkedField",
                                                                                "name": "person",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "alias": null,
                                                                                        "args": null,
                                                                                        "kind": "ScalarField",
                                                                                        "name": "primaryCalendarId",
                                                                                        "storageKey": null
                                                                                    }
                                                                                ],
                                                                                "storageKey": null
                                                                            },
                                                                            {
                                                                                "alias": null,
                                                                                "args": null,
                                                                                "concreteType": "TrialMetadata",
                                                                                "kind": "LinkedField",
                                                                                "name": "trialMetadata",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "alias": null,
                                                                                        "args": null,
                                                                                        "kind": "ScalarField",
                                                                                        "name": "trialEndDate",
                                                                                        "storageKey": null
                                                                                    },
                                                                                    (v5 /*: any*/)
                                                                                ],
                                                                                "storageKey": null
                                                                            }
                                                                        ],
                                                                        "storageKey": null
                                                                    }
                                                                ],
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "type": "FeatureGrid",
                                                        "abstractKey": null
                                                    },
                                                    (v1 /*: any*/)
                                                ],
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": (v2 /*: any*/),
                                                "concreteType": "SettingConnection",
                                                "kind": "LinkedField",
                                                "name": "settings",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "SettingEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "Setting",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    (v4 /*: any*/),
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "concreteType": "SettingKey",
                                                                        "kind": "LinkedField",
                                                                        "name": "key",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            (v4 /*: any*/),
                                                                            {
                                                                                "alias": null,
                                                                                "args": null,
                                                                                "kind": "ScalarField",
                                                                                "name": "name",
                                                                                "storageKey": null
                                                                            },
                                                                            {
                                                                                "alias": null,
                                                                                "args": null,
                                                                                "concreteType": "Urn",
                                                                                "kind": "LinkedField",
                                                                                "name": "scope",
                                                                                "plural": false,
                                                                                "selections": (v7 /*: any*/),
                                                                                "storageKey": null
                                                                            },
                                                                            {
                                                                                "alias": null,
                                                                                "args": null,
                                                                                "concreteType": "Urn",
                                                                                "kind": "LinkedField",
                                                                                "name": "target",
                                                                                "plural": false,
                                                                                "selections": (v7 /*: any*/),
                                                                                "storageKey": null
                                                                            }
                                                                        ],
                                                                        "storageKey": null
                                                                    },
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "concreteType": "SettingType",
                                                                        "kind": "LinkedField",
                                                                        "name": "type",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            (v4 /*: any*/),
                                                                            {
                                                                                "alias": null,
                                                                                "args": null,
                                                                                "kind": "ScalarField",
                                                                                "name": "valueType",
                                                                                "storageKey": null
                                                                            },
                                                                            {
                                                                                "alias": null,
                                                                                "args": null,
                                                                                "kind": "ScalarField",
                                                                                "name": "containerType",
                                                                                "storageKey": null
                                                                            },
                                                                            {
                                                                                "alias": null,
                                                                                "args": null,
                                                                                "kind": "ScalarField",
                                                                                "name": "required",
                                                                                "storageKey": null
                                                                            }
                                                                        ],
                                                                        "storageKey": null
                                                                    },
                                                                    (v6 /*: any*/)
                                                                ],
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": "settings(first:1000000)"
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "FeedScheduler_org"
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": "orgs(first:1000000)"
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Viewer",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'e4c23bcfe5280868f5d05ae8917a53d5';
export default node;
